import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Triangle } from "react-loader-spinner";

import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import Select from "react-select";
import SectionService from "../../../services/OrderingServices/SectionService";
import CreateSection from "../component/CreateSection";
import { Link, useNavigate } from "react-router-dom";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const Section = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);

  const fetchTable = async () => {
    setLoading(true);
    try {
      const response = await SectionService.getList();
      setData(response);
    } catch (error) {
      toast.error("Failed to fetch table data");
    } finally {
      setLoading(false);
    }
  };
// console.log(data)
  useEffect(() => {
    fetchTable();
  }, []);

  const toggleModal = (row = null) => {
    setSelectedTable(row);
    setIsModalOpen(!isModalOpen);
  };

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleDeleteClick = (id) => {
    setSelectedDeleteItem(id);
    toggleDeleteModal();
  };

  const handleDelete = async () => {
    try {
      const response = await SectionService.delete(selectedDeleteItem);
      setData((prev) => prev.filter((item) => item.id !== selectedDeleteItem));
      toast.success("Selected section is deleted successfull");
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      toast.error(error?.response?.data?.details);
    } finally {
      toggleDeleteModal();
      setSelectedDeleteItem(null);
    }
  };

  const getStatusBadge = (e) => {
    const statusStyles = {
      Occupied: "bg-danger",
      Available: "bg-success",
      Reserved: "bg-dark",
    };
    return (
      <span className={`badge ${statusStyles[e] || "bg-danger"}`}>
        {e || "No Data"}
      </span>
    );
  };
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    // {
    //   name: "Status",
    //   selector: (row) => getStatusBadge(row.tableStatus),
    //   sortable: true,
    // },
    {
      name: "Action",
      cell: (row) => (
        <ButtonGroup size="sm">
          <Link to={`/section/detail/${row.id}`}>
            <Button color="btn btn-soft-success" className="btn-sm">
              <i className="bx bx-show" />
            </Button>
          </Link>

          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => toggleModal(row)}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  const [filterText, setFilterText] = useState("");
  const [statusFilter, setStatusFilter] = useState(null); // <-- NEW

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };
  const handleStatusChange = (selectedOption) => {
    setStatusFilter(selectedOption);
  };
  const filteredData = data?.filter((pkg) => {
    const searchContext = `${pkg?.name || ""} `.toLowerCase();

    const matchesText = searchContext.includes(filterText.toLowerCase());
    // const matchesStatus = statusFilter
    //   ? pkg.tableStatus.toLowerCase() === statusFilter.label.toLowerCase()
    //   : true;

    return matchesText;
  });
  console.log(filteredData);
  const statusOptions = [
    { value: "Available", label: "Available" },
    { value: "Occupied", label: "Occupied" },
    { value: "Reserved", label: "Reserved" },
    // { value: "Cancelled", label: "Cancelled" },
  ];

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Section List" pageTitle="Section Management" />

        <Row>
          <Col md={8} className="mb-2">
            <InputGroup>
              <Input
                placeholder="Search by section name"
                value={filterText}
                onChange={handleFilterChange}
              />
            </InputGroup>
          </Col>
          {/* <Col xs={12} md={4}>
            <Select
              options={statusOptions}
              value={statusFilter}
              onChange={handleStatusChange}
              placeholder="Select Status"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Col> */}
          <Col
            md={4}
            xs={12}
            className="d-flex justify-content-end align-items-end mb-2"
          >
            <div className="d-flex justify-content-end mb-3">
              <Button
                className="btn btn-soft-success"
                onClick={() => toggleModal()}
              >
                + Create Section
              </Button>
            </div>
          </Col>
        </Row>
        <div className="d-none d-md-block d-lg-block">
        <CustomDataTable
          responsive
          striped
          pagination
          fixedHeader
          persistTableHead
          progressPending={loading}
          customStyles={customStyles}
          progressComponent={
            <div className="my-3">
              <Triangle
                visible={true}
                height="80"
                width="80"
                color="#5B71B9"
                ariaLabel="triangle-loading"
              />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
          columns={columns}
          data={filteredData}
        />
      </div> 
      
      <div  className="d-block d-md-none">

    
      {loading ? (
        <div className = "my-5 d-flex justify-content-center">
          <Triangle
            visible={true}
            height="60"
            width="60"
            color="#5B71B9"
            ariaLabel="triangle-loading"
          />
        </div>
      ):(
        <>
          {filteredData?.map((item,index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none"
              onClick={(e) => {
                e.stopPropagation(); // prevents parent click handlers

                navigate(`/section/detail/${item?.id}`);
              }}
            >
              <CardBody>
                <Row>
                  <Col xs={10}>
                    <h6 className="mb-2">Section: {`${item.name}`}</h6>
                    {/* <h6 className="mb-2 text-muted">
                      Parent Section: {item?.name}
                    </h6> */}
                    <h6 className="mb-2 text-muted">
                      Description: {item?.description}
                    </h6>
                    <span
                      className={`badge ${
                        item.isActive ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {item.isActive ? "Active" : "Inactive"}
                    </span>{" "}
                  </Col>
                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation(); // prevents parent click handlers

                          setData((prev) =>
                            prev.map(
                              (sectiondata) =>
                                sectiondata.id === item.id
                                  ? {
                                      ...sectiondata,
                                      dropdownOpen: !sectiondata.dropdownOpen,
                                    }
                                  : { ...sectiondata, dropdownOpen: false } // close all others
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm  shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={(e) => {
                              e.stopPropagation(); // prevents parent click handlers
                              toggleModal(item); // opens your modal with the item
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem
                            onClick={(e) => {
                              e.stopPropagation(); // prevents parent click handlers
                              handleDeleteClick(item.id);
                            }}
                          >
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
  </div>
  </div>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
      />

      <CreateSection
        isOpen={isModalOpen}
        toggle={toggleModal}
        selectedTable={selectedTable}
        refreshData={fetchTable}
      />
    </Container>
  );
};

export default Section;
